import {
    COMMUNITY,
    COMMUNITY_SUCCESS,
    COMMUNITY_ERROR,
    COMMUNITY_ID,
    COMMUNITY_ID_SUCCESS,
    COMMUNITY_ID_SUCCESS_CL,
    COMMUNITY_ID_ERROR,
    ADD_COMMUNITY,
    ADD_COMMUNITY_SUCCESS,
    ADD_COMMUNITY_ERROR,
    UPDATE_COMMUNITY,
    UPDATE_COMMUNITY_SUCCESS,
    UPDATE_COMMUNITY_ERROR,
    DELETE_COMMUNITY,
    DELETE_COMMUNITY_ERROR,
    DELETE_COMMUNITY_SUCCESS,
    COMMUNITY_MEALS_TYPE,
    COMMUNITY_MEALS_TYPE_SUCCESS,
    COMMUNITY_MEALS_TYPE_ERROR,
    UPDATE_COMMUNITY_IMAGE,
    UPDATE_COMMUNITY_IMAGE_SUCCESS,
    UPDATE_COMMUNITY_IMAGE_ERROR,
    GET_TAGS_COMMUNITY_SUCCESS,
    GET_TAGS_COMMUNITY_ERROR,
    GET_TAGS_COMMUNITY,
    COMMUNITY_BY_TAGS,
    COMMUNITY_BY_TAGS_ERROR,
    COMMUNITY_BY_TAGS_SUCCESS,
    CL_COMMUNITY,
    CL_COMMUNITY_ERROR,
    CL_COMMUNITY_SUCCESS
} from "../constants/communityConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function communityReducer(state = initialState, action) {
    switch (action.type) {
        case COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITIES ARE BEING LOADED',
                'type': action.type
            });
        case COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityData': Array.isArray(action.data) ? action.data : [],
                'communityAdded': undefined
            });
        case COMMUNITY_ID:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY ID IS BEING LOADED',
                'type': action.type
            });
        case COMMUNITY_ID_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case COMMUNITY_ID_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityAdded': undefined,
                'type': action.type
            });
        case COMMUNITY_ID_SUCCESS_CL:
            let communityDataCL = state.communityData ? [...state.communityData] : []
            communityDataCL.push(action.data);
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityAdded': undefined,
                'communityData': communityDataCL,
                'type': action.type
            });
        case ADD_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY IS BEING SAVED',
                'type': action.type
            });
        case ADD_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case ADD_COMMUNITY_SUCCESS:
            let addCommunityData = state.communityData ? [...state.communityData] : []
            addCommunityData.push(action.data);
            addCommunityData.sort((a, b) => { let comparsion = 0; if (a.communityName.toUpperCase() > b.communityName.toUpperCase()) comparsion = 1; else comparsion = -1; return comparsion });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityData': addCommunityData,
                'communityAdded': action.data
            });
        case UPDATE_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case UPDATE_COMMUNITY_SUCCESS:
            let communityData = state.communityData ? state.communityData : []
            let community = communityData.find((item) => item._id === action.data._id);

            if (community) {
                community = { ...community, ...action.data }
            }

            communityData = communityData.map((item) => { return item._id === action.data._id ? community : item });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityData': communityData,
                'communityAdded': undefined,
                'type': action.type
            });
        case DELETE_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY IS BEING DELETED',
                'type': action.type
            });
        case DELETE_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case DELETE_COMMUNITY_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'communityData': state.communityData.filter(item => item.communityId !== action.data),
                'communityAdded': undefined
            });
        case COMMUNITY_MEALS_TYPE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY MEALS ARE BEING LOADED',
                'type': action.type
            });
        case COMMUNITY_MEALS_TYPE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case COMMUNITY_MEALS_TYPE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'mealsData': action.data,
                'communityAdded': undefined
            });
        case UPDATE_COMMUNITY_IMAGE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'communityAdded': undefined,
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE COMMUNITY IMAGE IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_COMMUNITY_IMAGE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'communityAdded': undefined
            });
        case UPDATE_COMMUNITY_IMAGE_SUCCESS:
            let communityImageData = state.communityImageData ? state.communityImageData : []
            let communityImage = communityImageData.find((item) => item._id === action.data._id);

            if (communityImage) {
                communityImage = { ...communityImage, ...action.data }
            }

            communityImageData = communityImageData.map((item) => { return item._id === action.data._id ? communityImage : item });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': ''
            });
        case GET_TAGS_COMMUNITY:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case GET_TAGS_COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'tags': action.data
            });
        case GET_TAGS_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case COMMUNITY_BY_TAGS:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case COMMUNITY_BY_TAGS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'communityDataSTBVersion': action.data
            });
        case COMMUNITY_BY_TAGS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case CL_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'COMMUNITY',
                'loadingMessage': 'THE SYNC WITH CL IS IN PROGRESS',
                'type': action.type
            });
        case CL_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case CL_COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': ''
            });
        default:
            return state;
    }
}

export default communityReducer